const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-page">
        <div className="footer-logo-phone">
          <img src="/images/logo.png" alt="Trio Tim" />
        </div>
        <div className="footer-left">
          <div className="register-login">Kontakt</div>
          <div className="register-input" id="contact">
            <input type="text" placeholder="Ime" />
          </div>
          <div className="register-input">
            <input type="text" placeholder="e-mail" />
          </div>
          <div className="register-input">
            <input type="text" placeholder="Poruka" />
          </div>
          <div className="register-button">
            <button>Pošalji</button>
          </div>
        </div>
        <div className="footer-content">
          <img src="/images/logo.png" className="footer-logo" alt="ison logo" />
          <div className="footer-text">
            <b>Osnovni podaci</b> <br />
            <br />
            Email: office@triotim.rs <br />
            Adresa: TRG NIKOLE PAŠIĆA 7, 11000, Beograd <br />
            Telefon: 0611326103 <br />
            Telefon: 0631641853
          </div>
        </div>
      </div>
      <div className="footer-copyright">
        Copyright © 2025 Consulting Trio Tim d.o.o. All rights reserved
      </div>
    </div>
  );
};

export default Footer;
